import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../AuthContext';

function Login() {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });

    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value
        });
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setError(null);

        console.log('Login form:', formData);

        try {
            const response = await axios.post(
                'https://api.sivammoto.in/api/auth/login',
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            const data = response.data;

            console.log('Login response:', data);

            // ==========================================
            // SAVE LOGIN DATA
            // ==========================================
            login(
                data.user_id,
                data.access_token,
                data.name,
                data.email,
                data.user_type
            );

            console.log('User Type:', data.user_type);
            console.log('Local Storage:', localStorage);

            toastr.success('Logged in Successfully');

            // ==========================================
            // REDIRECT BASED ON USER TYPE
            // ==========================================

            if (String(data.user_type) === '4') {
                // User Type 4 -> ONLY Dealer
                navigate('/dealer');
            } else {
                // All other users -> Dashboard
                navigate('/dashboard');
            }

            // ==========================================
            // RESET FORM
            // ==========================================
            setFormData({
                username: '',
                password: ''
            });

        } catch (error) {

            if (error.response) {

                setError(error.response.data.error);

                console.log(
                    error.response.data.error
                );

                toastr.error(
                    error.response.data.error
                );

            } else {

                setError(
                    'An error occurred. Please try again.'
                );

                toastr.error(
                    'An error occurred. Please try again.'
                );
            }

        } finally {

            setLoading(false);

        }
    };

    return (
        <div className="login-page">

            <div className="section-authentication-cover">

                <div className="">

                    <div className="row g-0">

                        {/* ==========================================
                            LEFT LOGIN IMAGE
                        =========================================== */}
                        <div className="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex">

                            <div className="card shadow-none bg-transparent rounded-0 mb-0">

                                <div className="card-body">

                                    <img
                                        src="/dist/img/login-cover.svg"
                                        className="img-fluid auth-img-cover-login"
                                        width="650"
                                        alt="Login"
                                    />

                                </div>

                            </div>

                        </div>


                        {/* ==========================================
                            RIGHT LOGIN FORM
                        =========================================== */}
                        <div className="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center">

                            <div className="card rounded-0 m-5 shadow-none bg-transparent mb-0">

                                <div className="card-body p-sm-5">

                                    <div className="">

                                        <div className="form-body">

                                            <div className="login-box">

                                                <div className="card card-outline card-danger">

                                                    {/* ==========================================
                                                        HEADER
                                                    =========================================== */}
                                                    <div className="card-header text-center">

                                                        <h1 style={{ color: '#dc3545' }}>
                                                            <b>SHIVAM MOTO</b>
                                                        </h1>

                                                    </div>


                                                    {/* ==========================================
                                                        BODY
                                                    =========================================== */}
                                                    <div className="card-body">

                                                        <p className="login-box-msg">
                                                            Please log in to your account
                                                        </p>


                                                        <form onSubmit={handleSubmit}>

                                                            {/* ==========================================
                                                                EMAIL
                                                            =========================================== */}
                                                            <div className="input-group mb-3">

                                                                <input
                                                                    type="email"
                                                                    name="username"
                                                                    value={formData.username}
                                                                    onChange={handleChange}
                                                                    className="form-control"
                                                                    placeholder="Email"
                                                                    required
                                                                />

                                                                <div className="input-group-append">

                                                                    <div className="input-group-text">

                                                                        <span className="fas fa-envelope"></span>

                                                                    </div>

                                                                </div>

                                                            </div>


                                                            {/* ==========================================
                                                                PASSWORD
                                                            =========================================== */}
                                                            <div className="input-group mb-3">

                                                                <input
                                                                    type={
                                                                        showPassword
                                                                            ? 'text'
                                                                            : 'password'
                                                                    }
                                                                    name="password"
                                                                    value={formData.password}
                                                                    onChange={handleChange}
                                                                    className="form-control"
                                                                    placeholder="Password"
                                                                    required
                                                                />

                                                                <div className="input-group-append">

                                                                    <div className="input-group-text">

                                                                        <span
                                                                            style={{
                                                                                textDecoration: 'none',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            className={
                                                                                showPassword
                                                                                    ? 'fas fa-eye-slash'
                                                                                    : 'fas fa-eye'
                                                                            }
                                                                            onClick={
                                                                                togglePasswordVisibility
                                                                            }
                                                                        ></span>

                                                                    </div>

                                                                </div>

                                                            </div>


                                                            {/* ==========================================
                                                                REMEMBER ME
                                                            =========================================== */}
                                                            <div className="row">

                                                                <div className="col-8">

                                                                    <div className="icheck-danger">

                                                                        <input
                                                                            type="checkbox"
                                                                            id="remember"
                                                                        />

                                                                        <label htmlFor="remember">
                                                                            Remember Me
                                                                        </label>

                                                                    </div>

                                                                </div>

                                                            </div>


                                                            {/* ==========================================
                                                                LOGIN BUTTON
                                                            =========================================== */}
                                                            <div className="social-auth-links text-center mt-2 mb-3">

                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-block btn-danger"
                                                                    disabled={loading}
                                                                >

                                                                    {loading
                                                                        ? 'Signing in...'
                                                                        : 'Sign in'
                                                                    }

                                                                </button>

                                                            </div>

                                                        </form>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default Login;